var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "evm_log_row"
  }, [_c('section', {
    staticClass: "stats meta"
  }, [_c('article', {
    staticClass: "meta_row"
  }, [_c('p', {
    staticClass: "meta_label"
  }, [_vm._v(" Address "), _c('Tooltip', {
    attrs: {
      "content": "The smart contract that emitted this event"
    }
  })], 1), _c('div', {
    staticClass: "meta_value values"
  }, [_c('router-link', {
    attrs: {
      "to": "/evmaddress/".concat(_vm.log.address)
    }
  }, [_vm._v(_vm._s(_vm.log.address))])], 1)]), _vm.decodedLog ? _c('article', {
    staticClass: "meta_row"
  }, [_c('p', {
    staticClass: "meta_label"
  }, [_vm._v(" Name "), _c('Tooltip', {
    attrs: {
      "content": "The decoded name of this event"
    }
  })], 1), _c('div', {
    staticClass: "meta_value values"
  }, [_c('div', {
    staticClass: "method_id monospace"
  }, [_c('span', {
    staticClass: "margin-right"
  }, [_vm._v(_vm._s(_vm.decodedLog.name))]), _c('span', [_vm._v("(")]), _vm._l(_vm.decodedLog.events, function (event, i) {
    return _c('div', {
      key: i
    }, [i === 0 ? _c('span', {
      staticClass: "index_topic"
    }, [_vm._v("index_topic_1 ")]) : _vm._e(), i === 1 ? _c('span', {
      staticClass: "index_topic"
    }, [_vm._v("index_topic_2 ")]) : _vm._e(), _c('span', {
      staticClass: "arg_name"
    }, [_vm._v(_vm._s(event.name) + " ")]), _c('span', {
      staticClass: "arg_type"
    }, [_vm._v(_vm._s(event.type))]), i < _vm.decodedLog.events.length - 1 ? _c('span', {
      staticClass: "margin-right"
    }, [_vm._v(", ")]) : _vm._e()]);
  }), _c('span', [_vm._v(")")])], 2)])]) : _vm._e(), _c('article', {
    staticClass: "meta_row"
  }, [_c('p', {
    staticClass: "meta_label"
  }, [_vm._v(" Topics "), _c('Tooltip', {
    attrs: {
      "content": "Topics are indexed values emitted in the event, which can be used to efficiently search the blockchain"
    }
  })], 1), _c('div', {
    staticClass: "meta_value values"
  }, [_vm.log.topics[0] ? _c('div', {
    staticClass: "topic"
  }, [_c('div', [_vm._v("0")]), _c('div', {
    staticClass: "monospace"
  }, [_vm._v(_vm._s(_vm.log.topics[0]))])]) : _vm._e(), _vm.log.topics[1] ? _c('div', {
    staticClass: "topic"
  }, [_c('div', [_vm._v("1")]), _c('div', {
    staticClass: "monospace"
  }, [_vm._v(_vm._s(_vm.log.topics[1]))])]) : _vm._e(), _vm.log.topics[2] ? _c('div', {
    staticClass: "topic"
  }, [_c('div', [_vm._v("2")]), _c('div', {
    staticClass: "monospace"
  }, [_vm._v(_vm._s(_vm.log.topics[2]))])]) : _vm._e()])]), _vm.log.data ? _c('article', {
    staticClass: "meta_row"
  }, [_c('p', {
    staticClass: "meta_label"
  }, [_vm._v(" Data "), _c('Tooltip', {
    attrs: {
      "content": "Non-indexed values emitted in the event"
    }
  })], 1), _c('div', {
    staticClass: "meta_value values monospace"
  }, [_vm._v(" " + _vm._s(_vm.log.data) + " ")])]) : _vm._e()])]);
}
var staticRenderFns = []

export { render, staticRenderFns }